import { FormGroup } from '@angular/forms';
import { isEqual } from 'lodash-es';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { addRemoveError, getControl } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { getCoopTrasportoControl } from './helpers/coop-trasporto-form.helpers';
import { formPaths } from '@shared/constants/form-paths.const';

const TIPO_SEZ_ENTE_PATH = `${formPaths.datiIdentificativi}.my_TipoSezEnte`;

const modoRequiredHelper = (form: FormGroup, controlPath: string, errorKey: string, modoCondition: (modo: string) => boolean, extraCondition = true): void => {
    const control = getCoopTrasportoControl(form, controlPath);
    const my_ScTrasportoObbl: string = getCoopTrasportoControl(form, 'my_ScTrasportoObbl').value;
    const modo: string = getCoopTrasportoControl(form, 'my_ModoDiAssociazione').value;
    const errors = control.errors ?? {};

    addRemoveError(isNilOrEmpty(control.value) && modoCondition(modo) && (getAltreCoop(form) || my_ScTrasportoObbl === '1') && extraCondition, errors, errorKey, {
        status: REQUIRED_STATUS,
    });

    control.setErrors(isEqual(errors, {}) ? null : errors);
};

const getAltreCoop = (form: FormGroup): boolean => {
    const my_TipoSezEnte: string = getControl(form, TIPO_SEZ_ENTE_PATH)?.value;
    const my_CkAltreCoopAllegaSchedaTrasporto: string = getControl(form, 'my_SezioneI__Rilevazione.my_SchedaCoopAltreCoop.my_CkAltreCoopAllegaSchedaTrasporto')?.value ?? '';
    return my_TipoSezEnte === '10' && my_CkAltreCoopAllegaSchedaTrasporto === '1';
};

export const coopTrasportoRules: FormGroupRules = {
    my_ModoDiAssociazione: (form: FormGroup) => {
        const control = getCoopTrasportoControl(form, 'my_ModoDiAssociazione');
        const my_TipoSezEnte: string = getControl(form, TIPO_SEZ_ENTE_PATH)?.value;
        const errors = control.errors ?? {};

        addRemoveError(isNilOrEmpty(control.value) && (getAltreCoop(form) || my_TipoSezEnte === '8'), errors, 'my_ModoDiAssociazione', { status: REQUIRED_STATUS });

        control.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_ServiziOffertiAiSoci: (form: FormGroup) => {
        const my_CkAltriServiziOffertiAiSoci: string = getCoopTrasportoControl(form, 'my_CkAltriServiziOffertiAiSoci').value;
        modoRequiredHelper(form, 'my_ServiziOffertiAiSoci', 'my_ServiziOffertiAiSoci', (modo) => modo === 'Cooperativa di servizio', my_CkAltriServiziOffertiAiSoci === '1');
    },

    my_CkAltriServiziOffertiAiSoci: (form: FormGroup) => {
        modoRequiredHelper(form, 'my_CkAltriServiziOffertiAiSoci', 'my_CkAltriServiziOffertiAiSoci', (modo) => modo !== 'Cooperativa di lavoro');
    },

    my_CkPossideOfficine: (form: FormGroup) => {
        modoRequiredHelper(form, 'my_CkPossideOfficine', 'my_CkPossideOfficine', (modo) => modo !== 'Cooperativa di lavoro');
    },

    my_CkGestisceDistributoriCarburante: (form: FormGroup) => {
        modoRequiredHelper(form, 'my_CkGestisceDistributoriCarburante', 'my_CkGestisceDistributoriCarburante', (modo) => modo !== 'Cooperativa di lavoro');
    },

    my_CkGestisceRadioTaxi: (form: FormGroup) => {
        modoRequiredHelper(form, 'my_CkGestisceRadioTaxi', 'my_CkGestisceRadioTaxi', (modo) => modo !== 'Cooperativa di lavoro');
    },

    my_TitolareMezziLicenze: (form: FormGroup) => {
        modoRequiredHelper(form, 'my_TitolareMezziLicenze', 'my_TitolareMezziLicenze', (modo) => modo !== 'Cooperativa di servizio');
    },

    my_MezziLicenzeConferitiSoci: (form: FormGroup) => {
        const my_TitolareMezziLicenze: string = getCoopTrasportoControl(form, 'my_TitolareMezziLicenze').value;

        modoRequiredHelper(
            form,
            'my_MezziLicenzeConferitiSoci',
            'my_MezziLicenzeConferitiSociServizio',
            (modo) => modo === 'Cooperativa di servizio',
            my_TitolareMezziLicenze === '1'
        );

        modoRequiredHelper(form, 'my_MezziLicenzeConferitiSoci', 'my_MezziLicenzeConferitiSociLavoro', (modo) => modo === 'Cooperativa di lavoro', getAltreCoop(form));
    },
};

export const CoopTrasportoFormValidators = Object.values(coopTrasportoRules);
